import { capitalize } from '@mui/material';
import { PERIOD_COLUMN_WIDGET_TYPE } from '../../../utils/periodColumnWidget';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';
import { WATER_TANK_WIDGET_TYPE } from '../layout/webDashboardConstants';

export const getDefaultWidgetTitle = (type, t) => (
	type === 'time-range'
		? (t.widgetTitles?.timeRange || 'Digital Clock')
		: type === ENVIRONMENTAL_STATUS_WIDGET_TYPE
			? (t.widgetTitles?.environmentalStatus || 'Environmental Status')
			: type === ASSET_STATUS_WIDGET_TYPE
				? (t.widgetTitles?.assetStatus || 'Asset Status')
				: type === STATUS_ARROW_WIDGET_TYPE
					? (t.widgetTitles?.statusArrow || 'Status Arrow')
					: type === PERIOD_COLUMN_WIDGET_TYPE
				? (t.widgetTitles?.periodColumn || 'Period Column')
				: type === 'liquid'
					? (t.widgetTitles?.liquid || 'Liquid Widget')
					: type === WATER_TANK_WIDGET_TYPE
						? (t.widgetTitles?.waterTank || 'Water Tank')
						: type === 'push-button'
							? (t.widgetTitles?.pushButton || 'Push Button')
							: type === 'water-pump'
								? (t.widgetTitles?.waterPump || 'PUMP Widget')
								: capitalize(type)
);
